<template>
  <div>
    <div class="filters-wrapper">
      <div class="form-group">
        <input
          type="text"
          class="form-control full-width-input"
          v-model="searchFilters.search"
          @keyup.enter="onHandleSearch"
        />
      </div>

      <button
        class="btn btn-md btn-primary"
        @click="onHandleSearch"
        :disabled="isFetching"
      ><i class="fa-regular fa-search"></i> Search</button>
    </div>

    <div class="d-flex justify-content-center" v-if="isFetching">
      <event-spinner />
    </div>

    <template v-show="items?.length && !isFetching">
      <div
        class="speaker-wrapper"
        v-for="(item, itemIndex) in items"
        :key="`${itemIndex}`"
        :id="`speaker-${item.id}`"
      >
        <!-- speaker item -->
        <div class="speaker-info default-shadow">
          <figure class="speaker-item">
            <img
              v-if="item.photo"
              class="image"
              :src="item.photo ? item.photo : '/img/no-profile-picture.svg'"
              :alt="item.name ? item.name : 'Speaker Image'"
            />

            <figcaption>
              <h5><b>{{ item.name }}</b></h5>
              <div class="subtitle">{{ item.title }}</div>
            </figcaption>
          </figure>

          <div class="speaker-biography" v-html="item.bio"></div>

          <h3 class="session-header" v-if="item.sessions?.length && item.sessions?.length > 1">Sessions</h3>
          <h3 class="session-header" v-if="item.sessions?.length && item.sessions?.length === 1">Session</h3>

          <!-- session item -->
          <div
            v-for="(presenterSession, presenterSessionIndex) in item.sessions"
            :key="`presenterSessionIndex-${presenterSessionIndex}`"
            class="session-item"
          >
            <span class="session-date" v-if="item.start_at">{{ presenterSession.start_at }}</span>

            <span class="session-title">
            <a
              href="#"
              :class="`session-link-${presenterSession.id}`"
              @click.prevent="onOpenSessionDetailModal(presenterSession)"
              :data-id="presenterSession.id"
            >
              {{ presenterSession.code ? `${presenterSession.code} - ${presenterSession.name}` : presenterSession.name }}
            </a>
          </span>
          </div>
        </div>
      </div>
    </template>

    <div v-if="!items?.length && !isFetching" class="flex-table default-shadow">
      <h4>Speakers not found</h4>
    </div>

    <session-detail-modal
      v-if="showSessionDetailModal"
      :session="session"
      :slug="slug"
      :is-hybrid-conference="isHybridConference"
      :not-clickable-presenter="true"
    />
  </div>
</template>

<script>
import speakersAPI from "../../api/speakersAPI";
import SessionDetailModal from "../agenda-list/SessionDetailModal";

export default {
  props: {
    slug: {
      type: String,
      default: () => "",
    },
    organizationId: {
      type: Number,
      required: true,
    },
    conferenceId: {
      type: Number,
      required: true,
    },
    isHybridConference: {
      type: Boolean,
      required: true,
    }
  },
  components: {
    SessionDetailModal
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const presenterId = urlParams.get('presenter_id');

    if (presenterId) {
      this.fetchPresenterForScreenshot(presenterId);
    } else {
      this.fetch();
    }
  },
  data() {
    return {
      isFetching: false,
      items: [],
      showSessionDetailModal: false,
      session: {},
      searchFilters: {
        search: ''
      }
    }
  },
  computed: {},
  methods: {
    showModalsForScreenShots(array) {
      const urlParams = new URLSearchParams(window.location.search);
      const sessionId = urlParams.get('session_id');

      if (sessionId) {
        const uniqueSessions = new Set();

        array.forEach(presenter => {
          presenter.sessions.forEach(session => {
            uniqueSessions.add(session);
          });
        });

        const sessionsArray = [...uniqueSessions];

        if (sessionId) {
          const session = sessionsArray.find(item => item.id === +sessionId);

          if (session) {
            this.onOpenSessionDetailModal(session);
          }
        }
      }
    },

    goToPresenterFromUrl() {
      setTimeout(() => {
        const hash = window.location.hash;

        if (hash) {
          const element = document.querySelector(hash);

          if (element) {
            element.scrollIntoView({behavior: 'smooth'});
          }
        }
      }, 500)
    },

    fetchPresenterForScreenshot(presenterId) {
      this.isFetching = true;
      speakersAPI
        .fetch(this.slug, { presenter_id: presenterId })
        .then((res) => {
          this.items = res.data.data || [];
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false;
        });
    },

    fetch() {
      const params = this.searchFilters || {};

      this.isFetching = true;
      speakersAPI
        .fetch(this.slug, params)
        .then((res) => {
          this.items = res.data.data || [];

          this.goToPresenterFromUrl();

          this.showModalsForScreenShots(res.data.data);
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false;
        });
    },

    onOpenSessionDetailModal(item) {
      setTimeout(() => {
        $("#sessionDetailModalVue").modal({
          show: true,
          backdrop: "static",
          keyboard: false,
        });
      }, 500);

      this.showSessionDetailModal = true;
      this.session = item || {};
    },

    onCloseSessionDetailModal() {
      this.showSessionDetailModal = false;
      this.session = null;
    },

    onHandleSearch() {
      this.fetch();
    },

    onClearFilters() {
      this.searchFilters = {
        search: ''
      };

      this.fetch();
    }
  },
};
</script>

<style lang="scss" scoped>
.filters-wrapper {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;

  .form-group {
    flex-grow: 1;
    margin-bottom: 0;
  }

  .full-width-input {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
